import { Route } from "react-router-dom";
import ConfigCNPJSRestritosPrivatePage from "../../pages/private/configs/cnpjs_restritos";
import ConfigImpostosPrivatePage from "../../pages/private/configs/impostos";
import ConfigMenusPrivatePage from "../../pages/private/configs/menus";
import ConfigPermissionsPrivatePage from "../../pages/private/configs/permissions";
import ConfigProfilePrivatePage from "../../pages/private/configs/profile";
import ConfigTokensAssinaturasPrivatePage from "../../pages/private/configs/tokens";
import ConfigUpdatersPrivatePage from "../../pages/private/configs/updaters";
import ConfigUsersPrivatePage from "../../pages/private/configs/users";

const RoutesConfigs = () => {
  return (
    <Route path="/configuracoes">
      <Route path="menus" element={<ConfigMenusPrivatePage />} />
      <Route path="permissoes" element={<ConfigPermissionsPrivatePage />} />
      <Route path="perfil" element={<ConfigProfilePrivatePage />} />
      <Route path="atualizacoes" element={<ConfigUpdatersPrivatePage />} />
      <Route path="usuarios" element={<ConfigUsersPrivatePage />} />
      <Route path="impostos" element={<ConfigImpostosPrivatePage />} />
      <Route path="cnpjs" element={<ConfigCNPJSRestritosPrivatePage />} />
      <Route path="tokens" element={<ConfigTokensAssinaturasPrivatePage />} />
    </Route>
  );
};

export default RoutesConfigs;
